import MemberNews from "@/views/ContentView/MemberNews.vue";
import Announcements from "@/views/ContentView/Announcements.vue";
import HomeContents from "@/views/ContentView/HomeContents.vue";

import DashboardLayout from "@/views/LayoutView/DashboardLayout.vue";

const contentsMenu = {
  path: "/contents",
  component: DashboardLayout,
  redirect: "/contents/home",
  name: "contents",
  children: [
    {
      path: "home",
      name: "content-home",
      components: { default: HomeContents },
      meta: { requiresAuth: true, requiredRoles: ["content", 'master'], title: 'title.homepage_management' },
    },
    {
      path: "announcements",
      name: "content-announcement",
      components: { default: Announcements },
      meta: { requiresAuth: true, requiredRoles: ["content", 'master'], title: 'title.announcement_management' },
    },
    {
      path: "member-news",
      name: "content-member-news",
      components: { default: MemberNews },
      meta: { requiresAuth: true, requiredRoles: ["content", 'master'], title: 'title.membernews_management' },
    },
  ],
};

export default contentsMenu;
